import { NestedTreeControl } from '@angular/cdk/tree';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ActivatedRoute, Router } from '@angular/router';
import { getConfig, hideSpinner,showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MenuService, ModuloMenu, OpcionMenu } from 'src/app/core/services/menu.service';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.scss']
})
export class HomeLayoutComponent implements OnInit, AfterViewInit {
  @Input() isSearch: boolean = false;
  @ViewChild('tree') tree;


  title = "Home";
  dominio = environment.domain + "/";
  modulesRoute = environment.adminRoute;

  modules: ModuloMenu[] = [];
  recentModules: ModuloMenu[] = [];
  treeModules: TreeModule[] = [];
  treeRecentModules: TreeModule[] = [];


  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private helpers: HelpersService,
    private menuService: MenuService,
    private authService: AuthService,
    private dialog: MatDialog
  ) {
    const data = this.activatedRoute.snapshot.data
    if (data && data.title) {
      this.helpers.setTitle(data.title)
    }

    // Verifica si el usuario está autenticado
    if (!this.authService.isAuthenticated()) {
      this.router.navigate([getConfig("route_on_forbidden")])
    }
  }

  async ngOnInit() {
    this.menuService.deleteCurrentModuleOptions();

     // Obtener módulos disponibles desde el servicio
    this.modules = this.menuService.getModules();

    if (this.modules && this.modules.length > 0) {
      //si hay modulos, se filtran los recientes
      if (!this.isSearch) {//Si es busqueda no se muestran los recientes
        this.recentModules = this.menuService.getRecentModules()

         // Quitar los módulos recientes de la lista de todos los módulos
        this.modules = this.menuService.getModules().filter(module => {
          return !this.recentModules.find(recent => {
            return module.codigo_modulo == recent.codigo_modulo
          })
        })
      }
    } else {
      // Si no hay módulos cargados, hacer request al servidor
      showSpinner("Cargando modulos");
      await this.menuService.requestModules()
      hideSpinner()
      this.modules = this.menuService.getModules()
    }
    this.generateTrees()
  }

   // Genera un control de árbol para manejar la expansión de nodos
  generateTrees() {
    this.treeRecentModules = []
    this.treeModules = []
    this.recentModules.forEach(recent => {
      this.treeRecentModules.push({
        module: recent,
        treeControl: this.getTreeControl(recent),
        dataSource: this.getTreeDataSource(recent)
      })
    });
    this.modules.forEach(recent => {
      this.treeModules.push({
        module: recent,
        treeControl: this.getTreeControl(recent),
        dataSource: this.getTreeDataSource(recent)
      })
    });
  }

  ngAfterViewInit() {
  }

  getTreeControl(module: ModuloMenu): NestedTreeControl<OpcionMenu> {
    const treeControl = new NestedTreeControl<OpcionMenu>(node => node.rutas);
    const menuOptions = new MatTreeNestedDataSource<OpcionMenu>();
    menuOptions.data = module.opciones ? module.opciones : []
    treeControl ? treeControl.dataNodes = menuOptions.data : ""
    return treeControl
  }

  getTreeDataSource(module: ModuloMenu): MatTreeNestedDataSource<OpcionMenu> {
    const menuOptions = new MatTreeNestedDataSource<OpcionMenu>();
    menuOptions.data = module.opciones ? module.opciones : []
    return menuOptions
  }

  async goToModule(module: ModuloMenu, option: OpcionMenu | undefined = undefined) {
    showSpinner("Cargando opciones del módulo");

    // Obtener opciones del módulo desde API si aún no están cargadas
    const options = module.opciones && module.opciones.length 
    ? module.opciones
    : await this.menuService.getOptionsByModule(module.codigo_modulo!)

    

    hideSpinner();
    
    if (options.length) {
      module.opciones = options;
      this.menuService.setCurrentModuleOptions(module);
      this.menuService.addRecentModule(module);

      if (option) {
        this.router.navigate(["/admin/" + option.ruta])
      } else {
        this.router.navigate(["/admin"]);
      }
      this.dialog.closeAll();
    } else {
      this.helpers.notifications.warningMessage("Lo sentimos, este módulo no tiene rutas accesibles todavía")
    }
  }

  search(value: string) {
    const all = this.menuService.searchModule(value);
    this.modules = all;
    this.generateTrees();
  }

  hasRutas(_: number, value: OpcionMenu): boolean {
    return value.rutas != undefined && Array.isArray(value.rutas) && value.rutas.length > 0;
  }
}

interface TreeModule {
  module: ModuloMenu
  treeControl: NestedTreeControl<OpcionMenu>
  dataSource: MatTreeNestedDataSource<OpcionMenu>
}